<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-autocomplete
        v-if="multiple"
        outline
        v-model="select_store"
        :items="stores"
        item-text="name"
        item-value="id"
        label="أختر  المخزن التابع لك"
        persistent-hint
        return-object
        single-line
        @change="store_fatworas"
      >
        <template v-slot:append-outer>
          <v-slide-x-reverse-transition mode="out-in">
          </v-slide-x-reverse-transition>
        </template>
      </v-autocomplete>
      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        :loading="loading"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': '#D4B1B1' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.taslim_date }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">
              {{ props.item.store ? props.item.store.name : "" }}
            </td>

            <td style="padding:0px">
              <v-btn
                small
                color="orange"
                style="margin:0px;padding:0px"
                @click.prevent="sarf_from_store_confirm(props.item)"
              >
                <!-- @click="confirm_fatwora" -->
                تاكيد
              </v-btn>
              <v-btn
                small
                color="red"
                style="margin:4px 0px;padding:0px"
                @click.prevent="sarf_from_store_reject(props.item)"
              >
                <!-- @click="confirm_fatwora" -->
                رفض
              </v-btn>
            </td>
            <td>
              <textarea v-model="props.item.reason" name="" id=""></textarea>
            </td>
            <td>
              <router-link :to="'/FinalFatworasPrint/' + props.item.id"
                ><v-icon>print</v-icon></router-link
              >
            </td>

            <td>
              <v-icon
                style="curser:pointer"
                v-if="permissions.delete_all == 1 || user.type == 1"
                @click="delete_fatwora(props.item)"
                >delete</v-icon
              >
            </td>
          </tr>
        </template>
      </v-data-table>

      <br />

      <v-toolbar flat color="white">
        <v-toolbar-title> الفواتير المؤكد عليها سابقا</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>

      <v-data-table
        :headers="headers2"
        :items="fatworas_done"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': '#D4B1B1' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.taslim_date }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">
              {{ props.item.store ? props.item.store.name : "" }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.client && props.item.client.mandob_sales
                  ? props.item.client.mandob_sales.name
                  : ""
              }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.client && props.item.client.mandob_taworid
                  ? props.item.client.mandob_taworid.name
                  : ""
              }}
            </td>
            <td>
              <router-link :to="'/FinalFatworasPrint/' + props.item.id"
                ><v-icon>print</v-icon></router-link
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import {
  sarf_from_store_fatworas,
  sarf_from_store_confirm,
  sarf_from_store_reject,
  add_fatwora,
  delete_fatwora,
  stores_of,
  madionia_client,
  search_client_by_code,
  delete_fatwora_client_before_store,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    item_detail: {},
    detail_dialog: false,

    select_sadad_type: { id: "", job_name: "", name: "أختر نوع السداد" },
    select_client: { id: "", job_name: "", name: "أختر المورد" },
    select_employer: { id: "", job_name: "", name: "أختر المسئول" },
    select_store: {},
    select_item: { id: "", job_name: "", name: "أختر الصنف" },
    select_sadadstatuses: { name: "" },

    search: "",
    loading: false,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "الكود ",
        align: "right",
        value: ""
      },
      { text: "السعر ", value: "", align: "right" },
      { text: " اسم العميل", value: "", align: "right" },
      { text: "  تاريخ التسليم", value: "", align: "right" },
      { text: " التاريخ", value: "", align: "right" },
      { text: " المخزن", value: "", sortable: false, align: "right" },
      { text: " تأكيد", value: "", sortable: false, align: "right" },
      { text: " سبب الرفض", value: "store", sortable: false, align: "right" },
      { text: " تعين وطباعة", value: "store", sortable: false, align: "right" },
      { text: " حذف", value: "store", sortable: false, align: "right" }
    ],
    headers2: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "السعر ", value: "price_after", align: "right" },
      { text: " اسم العميل", value: "client_name", align: "right" },
      { text: "  تاريخ التسليم", value: "taslim_date", align: "right" },
      { text: " التاريخ", value: "taslim_date", align: "right" },
      { text: " المخزن", value: "store", sortable: false, align: "right" },
      {
        text: " مندوب التوزيع",
        value: "store",
        sortable: false,
        align: "right"
      },
      {
        text: "مندوب التوريد",
        value: "store",
        sortable: false,
        align: "right"
      },
      { text: " تعين وطباعة", value: "store", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      {
        text: " العدد النهائي",
        value: "item_num_after",
        sortable: false,
        align: "right"
      },
      {
        text: "   البونص",
        value: "item_bonus",
        sortable: false,
        align: "right"
      }
    ],

    fatworas: [],
    fatworas_done: [],
    m_sadad_types: [],
    m_employers: [],
    clients: [],
    m_items: [],
    stores: [],
    client_search_name: "",
    sadadstatuses: [],
    newItem: {
      id: "",
      code: "",
      madionia_sabqa: "",
      madionia_sabqa_of_madionia: "",
      madionia_now: "",
      discount: "",
      price_before: "",
      price_after: "",
      sdad_type_name: "",
      sdad_status: "",
      emp_bill_amr: "",
      emp_create_fatwora: "",
      emp_sales_response_name: "",
      client_name: "",
      taslim_date: "",
      store_id: "",
      sadad_type_id: "",
      client_id: "",
      emp_sales_response_id: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      client_id: "",
      emp_id: ""
    },
    added_items: [],
    multiple: false
  }),

  computed: {
    mycode() {
      if (this.fatworas.length > 0) {
        return (this.code =
          parseInt(this.fatworas[this.fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    gettotalpriceitem: function() {
      return function(q, p) {
        return parseInt(q) * parseFloat(p);
      };
    },
    get_item_num_after: function() {
      return function(n, b) {
        if (b != 0) {
          return parseInt(n) + parseFloat(b);
        }
        return parseInt(n);
      };
    },
    get_item_final_price: function() {
      return function(p, d) {
        if (d != "") {
          return parseFloat(p) - parseFloat(d);
        }
        return parseFloat(p);
      };
    },

    fatwora_price() {
      let tot_price = 0;
      for (let index = 0; index < this.added_items.length; index++) {
        tot_price += parseFloat(this.added_items[index].total_price);
      }
      return (this.newItem.price_before = tot_price);
    },
    fatwora_final_price() {
      if (this.newItem.price_before != "" && this.newItem.discount != "") {
        return (this.newItem.price_after =
          parseFloat(this.newItem.price_before) -
          parseFloat(this.newItem.discount));
      }
      return (this.newItem.price_after = this.newItem.price_before);
    },
    madionia_now() {
      if (this.newItem.price_after > 0) {
        return (this.newItem.madionia_now =
          parseFloat(this.newItem.madionia_sabqa) +
          parseFloat(this.newItem.price_after));
      }
      return (this.newItem.madionia_now = this.newItem.madionia_sabqa);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    // this.initialize()
    // sadadtypes().then(response => {
    //   this.m_sadad_types = response.data;
    // });

    // employers().then(response => {
    //   this.m_employers = response.data;
    // });

    // items().then(response => {
    //   this.m_items = response.data;
    // });

    // clients().then(response => {
    //   this.clients = response.data;
    // });

    stores_of().then(response => {
      this.multiple = response.data.multiple;
      this.stores = response.data.stores;
      this.multiple ? "" : (this.fatworas = response.data.fatwora);
      this.multiple ? "" : (this.fatworas_done = response.data.fatwora_done);
      this.multiple
        ? ""
        : (this.pagination.totalItems = response.data.fatwora_done.length);
    });

    // sadadstatuses().then(response => {
    //   this.sadadstatuses = response.data;
    // });
  },

  methods: {
    initialize() {},

    store_fatworas() {
      this.loading = true;
      let id = this.select_store.id;
      sarf_from_store_fatworas(id).then(response => {
        this.fatworas = response.data.fatwora;
        this.fatworas_done = response.data.fatwora_done;
        this.pagination.totalItems = response.data.fatwora_done.length;
        this.loading = false;
      });
    },

    add_item() {
      this.added_items.push({
        item_name: this.select_item.name,
        item_num_before: "",
        item_num: 1,
        item_num_after: "",
        item_discount: "",
        item_bonus: "",
        price: this.select_item.price_sell,
        total_price: this.select_item.total_price,
        final_price: this.select_item.final_price,
        item_id: this.select_item.id
      });
      this.select_item = { id: "" };
    },
    remove_item(item) {
      const index = this.added_items.indexOf(item);
      this.added_items.splice(index, 1);
    },
    change_client_name() {
      this.newItem.client_name = this.select_client.name;
      madionia_client(this.select_client.id).then(response => {
        this.newItem.madionia_sabqa = response.data.madionia;
        this.madionia_sabqa_of_madionia = response.data.madionia;
      });
    },
    change_employer_name() {
      this.newItem.emp_sales_response_name = this.select_employer.name;
    },
    change_sadad_name() {
      this.newItem.sdad_type_name = this.select_sadad_type.name;
    },
    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_fatwora(frmData2, item.id).then(response => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.code = this.code;
          this.newItem.sadad_type_id = this.select_sadad_type.id;
          this.newItem.client_id = this.select_client.id;
          this.newItem.emp_sales_response_id = myUser.id;
          this.newItem.store_id = this.select_store.id;
          this.newItem.sdad_status = this.select_sadadstatuses.name;
          this.newItem.taslim_date = this.date;
          this.newItem.status = "1";
          this.newItem.emp_fatwora_taslim = myUser.name;

          this.madionia.madionia_before = this.newItem.madionia_sabqa;
          this.madionia.cost_or_money = this.newItem.price_after;
          this.madionia.madionia_after = this.newItem.madionia_now;
          this.madionia.emp_name = myUser.name;
          this.madionia.type_of_operation = "fatwora";
          this.madionia.code_of_operation = this.newItem.code;
          this.madionia.client_id = this.select_client.id;
          this.madionia.emp_id = myUser.id;

          var frmData = new FormData();
          frmData.append("fatwora", JSON.stringify(this.newItem));
          frmData.append("fatwora_items", JSON.stringify(this.added_items));
          frmData.append("madionia", JSON.stringify(this.madionia));

          add_fatwora(frmData).then(response => {
            Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_sadad_type, this.$options.data().select_sadad_type);
            // Object.assign(this.$data.select_client, this.$options.data().select_client);
            // Object.assign(this.$data.select_employer, this.$options.data().select_employer);
            // Object.assign(this.$data.added_items, this.$options.data().added_items);
            // Object.assign(this.$data.select_item, this.$options.data().select_item);
            this.fatworas.push(response.data);
            this.loading = false;
            this.close();
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    },

    search_client_by_code() {
      search_client_by_code(this.client_search_name).then(response => {
        this.select_client = response.data;
        this.change_client_name();
      });
    },

    sarf_from_store_confirm(item) {
      let myUser = JSON.parse(localStorage.getItem("user"));
      var frmData = new FormData();
      frmData.append("emp_from_store", myUser.name);
      this.loading = true;
      sarf_from_store_confirm(item.id, frmData).then(response => {
        this.loading = false;
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "تاكيد الصرف من المخزن");
        frmData3.append(
          "body",
          "تم تاكيد الصرف من المخزن  " +
            this.select_store.name +
            " لفاتورة بكود " +
            item.code +
            " بواسطة " +
            myUser.name
        );
        frmData3.append("type", "sarf_from_store");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "تاكيد الصرف من المخزن";
            let mybody =
              "تم تاكيد الصرف من المخزن  " +
              this.select_store.name +
              " لفاتورة بكود " +
              item.code +
              " بواسطة " +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }

          setTimeout(() => {
            this.$router.go(0);
          }, 3000);
        });
      });
    },
    sarf_from_store_reject(item) {
      var frmData = new FormData();
      frmData.append("reason", item.reason);
      this.loading = true;
      sarf_from_store_reject(item.id, frmData).then(response => {
        this.loading = false;
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "رفض الصرف من المخزن");
        frmData3.append(
          "body",
          "تم رفض الصرف من المخزن  " +
            this.select_store.name +
            " لفاتورة بكود " +
            item.code +
            " بواسطة " +
            myUser.name
        );
        frmData3.append("type", "sarf_from_store_reject");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "رفض الصرف من المخزن";
            let mybody =
              "تم تاكيد الصرف من المخزن  " +
              this.select_store.name +
              " لفاتورة بكود " +
              item.code +
              " بواسطة " +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }
        });
      });
    },
    detailItem(order) {
      this.item_detail = order;
    },
    delete_fatwora(item) {
      this.$swal({
        title:
          " شرط لحذف الفاتورة ان تكون اخر فاتورة لنفس العميل حتي لا تؤثر علي المديونية ..هل تريد الأستمرار ",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);

          this.loading = true;
          delete_fatwora_client_before_store(item.id).then(res => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
